import React, {useState} from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import TextField from '../components/InputFields/TextField';
import SelectField from '../components/InputFields/SelectField';
import { BsEyeFill } from 'react-icons/bs'
import * as Yup from 'yup'
import { Rings } from 'react-loader-spinner'

import Requirements from '../components/PassowrdRequirements/Requirements'
import { _SIGN_UP } from '../redux/auth/authActions';

const Signup = ({_SIGN_UP}) => {
    const [loadButton, setLoadButton] = useState(false);
    const [long, longEnough] = useState(false);
    const [number, hasNumber] = useState(false);
    
    const validate = Yup.object({
        username: Yup.string()
            .min(3)
            .required('Username is required'),
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
        business_name: Yup.string()
            .min(3)
            .required('Business name is required'),
        phone: Yup.string()
            .min(11),
        country : Yup.string()
            .required('Country is required'),
        password: Yup.string()
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+,.\\/;':"-]).{8,}$/,
                "Must At Least 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character")
            .required('Password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Password must match')
            .required("The password you entered does not match"),
    })

  return (
    <div className='login'>
        <div className="onboard__container">
            <h1>Sign Up</h1>
            <Formik
                initialValues={{ 

                    username: '',
                    email: '', 
                    country: '',
                    phone: '',
                    business_name: '',
                    password: '',
                    confirmPassword: ''

                }}

                validate={values => {
                    values.password.length < 8 ? longEnough(false) : longEnough(true);
                    !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+,.\\/;':"-]).{8,}$/.test(values.password) ? hasNumber(false) : hasNumber(true);
                  }}

                validationSchema={validate}
                onSubmit = {( values, {resetForm, setErrors}) => {
                    const {email, username, business_name, phone, password, country} = values;

                    let errors = {};
                    
                    if (!long || !number)
                    errors.password =
                    "Your password doesn't currently meet the requirements";
                    
                    // If the errors objcet is empty then we've successfully met all the requirements
                    if ( Object.entries(errors).length === 0 && errors.constructor === Object ) {
                        _SIGN_UP(email, password, country, business_name, phone, username,resetForm, setLoadButton)
                        setLoadButton(true);
                    } else {
                        setErrors(errors);
                    }


                }}
            >

                {formik => (

               
                    <div className="form__container">
                        <Form action="#" className="onboard__form__control">

                            <TextField label="Username" name='username' type="text" />

                            <TextField label="Email" name='email' type="email" />

                            <TextField label="Phone Number" name='phone' type="text" />

                            <TextField label="Bsuiness Name" name='business_name' type="text" /> 

                            <SelectField label="Country" name="country" />

                            <TextField label="Password" name='password' type="password" />

                            <TextField label="Confirm Password" name='confirmPassword' type="password" />

                            <div className="verification">
                                <Requirements long={long} number={number} />
                            </div>

                            <div className="signin__container">
                                <Link to="/signin" style={{ textDecoration: 'none' }}><h5 className='signin__here'>Already have an account?</h5></Link>
                                                
                            </div>

                            <button 
                                className='btn onboard__input submit' 
                                type="submit"  
                                disabled={loadButton ? true: false }
                            >
                                Sign Up 
                                {loadButton && <Rings ariaLabel="loading-indicator" color='#fff' width={50} height={30}/>}
                            </button>
                        </Form>
                    </div>

                )}              
            </Formik>
        </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
    _SIGN_UP: (email, password, country, username, business_name, resetForm, setLoadButton) => dispatch(_SIGN_UP(email, password, country, username, resetForm, setLoadButton))
})

export default connect(null, mapDispatchToProps)(Signup)